<div class="right-panel">
  <div class="panel-header">
    <div class="header-top flex items-center justify-between">
      <div class="title-group flex items-center">
        <h3 class="panel-title">{{ title }}</h3>
        @if (stage?.location) {
          <span class="location-tag" [ngClass]="stage?.location">{{ stage?.location | titlecase }}</span>
        }
      </div>
      <div class="header-actions flex items-center">
        <div class="flex items-center gap-2">
          @if (ago$ | async; as ago) {
            <span class="fs-12 fw-400">{{ ago.key | transloco: ago.params }}</span>
          }
        </div>

        <button type="button" class="icon-btn"
          [attr.aria-label]="'BUTTONS.REFRESH' | transloco" (click)="onRefresh()">
          <mat-icon svgIcon="refresh" class="icon-sm" [ngClass]="{ 'animate-spin': isSpinning }"></mat-icon>
        </button>

        <!-- <button type="button" class="icon-btn" [class.disabled]="downloadDisabled"
          [attr.aria-label]="'BUTTONS.DOWNLOAD' | transloco" (click)="onDownload()">
          <mat-icon svgIcon="file_download" class="icon-sm"></mat-icon>
        </button> -->

        <button type="button" class="close-btn" [attr.aria-label]="'BUTTONS.CLOSE' | transloco" (click)="onClose()">
          <mat-icon svgIcon="close" class="icon-lg"></mat-icon>
        </button>
      </div>
    </div>

    @if (stage && hasCounts) {
      <div class="count-strip">
        @for (item of countItems; track item.key) {
          <div class="count-item" [ngClass]="'count-' + item.key">
            <span class="count-label">{{ item.label }}:</span>
            <span class="count-value">{{ item.value }}</span>
          </div>
        }
      </div>

      <div class="filter-panel">
        <div class="filter-row">
          <div class="comp-type-dropdown" #typeDropdown>
            <button type="button" class="comp-type-trigger"
              [class.open]="typeMenuOpen"
              [attr.aria-expanded]="typeMenuOpen"
              aria-haspopup="listbox"
              (click)="toggleTypeMenu()">
              <span class="comp-type-label">{{ selectedTypeLabel }}</span>
              <svg class="comp-type-chevron" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>

            @if (typeMenuOpen) {
              <ul class="comp-type-menu" role="listbox">
                @for (opt of componentTypeOptions; track opt.value) {
                  <li class="comp-type-option" role="option"
                    [class.selected]="opt.value === selectedType"
                    [attr.aria-selected]="opt.value === selectedType"
                    (click)="selectType(opt.value)">
                    {{ opt.label }}
                  </li>
                }
              </ul>
            }
          </div>

          <div class="search-field">
            <mat-icon class="search-icon" svgIcon="search"></mat-icon>
            <input type="search" class="search-input"
              placeholder="Search components..."
              [value]="searchText"
              (input)="onSearchChange($event)" />
          </div>
        </div>

        <div class="flex flex-row status-buttons">
          @for (status of filterColumns; track status.key) {
            <button mat-button class="mr-12 status-btn"
              [ngClass]="selectedStatus === status.key ? 'btn-active' : 'btn-inactive'"
              (click)="selectStatus(status.key)">{{ status.label }}{{ status.count }}</button>
          }
        </div>
      </div>
    }
  </div>

  @if (stage?.components && stage.components.length > 0 && filteredComponents.length > 0) {
    <div class="components-list">
      @for (component of filteredComponents; track trackRow(component, $index)) {
        <div class="component-item" [class.expanded]="component.arrowClick">

          <div class="component-header" (click)="onExpandArrowClick(component)"
            [attr.aria-expanded]="component.arrowClick">

            <div class="component-info-section">
              <span class="status-icon"
                [ngClass]="'bar-' + getBarState(component)"
                [class.status-icon--spinning]="component.status === 'inprogress'">
              </span>
              <div class="component-title">
                <span class="component-name" [class.is-empty]="!component.name">{{ component.name || '--' }}</span>
                <span class="component-type" [class.is-empty]="!component.componentType">{{ component.componentType ? (component.componentType | titlecase) : '--' }}</span>
              </div>
            </div>

            <div class="component-time">
              <div class="time-line">
                <span class="time-elapsed">{{ calculateDuration(toUtcString(component?.start), toUtcString(component?.end)) }}</span>
                <span class="time-of"> of </span>
                <span class="time-expected">{{ getExpectedLabel(component) }}</span>
              </div>
              <span class="time-label">estimated</span>
            </div>

            <div class="component-progress" [ngClass]="'bar-' + getBarState(component)">
              <div class="progress-track">
                <div class="progress-fill" [style.width.%]="getProgressPercent(component)"></div>
                <div class="progress-marker"></div>
              </div>
              <span class="progress-label">
                @if (component.status === 'success' && getDeviationPercent(component) > 0) {
                  Completed · <strong>{{ getDeviationPercent(component) }}% faster</strong>
                } @else {
                  {{ getProgressLabel(component) }}
                }
              </span>
            </div>

            <span class="component-chevron" aria-hidden="true">
              <mat-icon [svgIcon]="component.arrowClick ? 'expand_less' : 'expand_more'" class="w-18 h-18"></mat-icon>
            </span>
          </div>

          <!-- Details: shown when the row is expanded, inside the same card -->
          @if (component?.arrowClick) {
            <div class="component-details" [@detailExpand]="component?.arrowClick ? 'expanded' : 'collapsed'"
              [ngClass]="[component?.status, component.performance]"
              [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_COMPONENT_DETAILS' | transloco: { name: component.name }">

              <div class="details-row">
                <div class="detail-item" [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_COMPONENT_STATUS' | transloco: { status: component.status }">
                  <span class="detail-label">{{ 'ACTIVITY_DETAILS.STATUS' | transloco }}</span>
                  <span class="detail-value component-status" [ngClass]="component?.status">
                    @if (component?.status === 'inprogress') {
                      <mat-spinner diameter="16" class="progress-color" mode="indeterminate"></mat-spinner>
                    } @else {
                      <mat-icon [svgIcon]="statusIcon[component?.status]" class="h-14 w-14"></mat-icon>
                    }
                    <span>{{ (component.status === 'success' ? ('ACTIVITY_DETAILS.STATUS_COMPLETED' | transloco) : component.status || '--') | titlecase }}</span>
                  </span>
                </div>
                <div class="detail-item" [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_START_TIME' | transloco: { time: (component?.start ? formatActivityDateTime(toUtcString(component?.start)) : ('ACTIVITY_DETAILS.NOT_AVAILABLE' | transloco)) }">
                  <span class="detail-label">{{ 'ACTIVITY_DETAILS.START_TIME' | transloco | titlecase }}</span>
                  <span class="detail-value">{{ component?.start ? formatActivityDateTime(toUtcString(component?.start)) : '--' }}</span>
                </div>
                <div class="detail-item" [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_END_TIME' | transloco: { time: (component?.end ? formatActivityDateTime(toUtcString(component?.end)) : ('ACTIVITY_DETAILS.NOT_AVAILABLE' | transloco)) }">
                  <span class="detail-label">{{ 'ACTIVITY_DETAILS.END_TIME' | transloco | titlecase }}</span>
                  <span class="detail-value">{{ component?.end ? formatActivityDateTime(toUtcString(component?.end)) : '--' }}</span>
                </div>
                <div class="detail-item" [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_COMPONENT_DURATION' | transloco: { duration: calculateDuration(toUtcString(component?.start), toUtcString(component?.end)), performance: performanceText(component) }">
                  <span class="detail-label">{{ 'ACTIVITY_DETAILS.DURATION' | transloco }}</span>
                  <span class="detail-value">{{ calculateDuration(toUtcString(component?.start), toUtcString(component?.end)) }} {{ performanceText(component) }}</span>
                </div>
              </div>

              <div class="details-row">
                <div class="detail-item" [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_WARNING_LIMIT' | transloco: { limit: (component?.health?.warning === 'true' || component?.health?.warning === true ? warningLimitText(component) : '--') }">
                  <span class="detail-label">{{ 'ACTIVITY_DETAILS.WARNING_LIMIT' | transloco | titlecase }}</span>
                  <span class="detail-value">{{ component?.health?.warning === 'true' || component?.health?.warning === true ? warningLimitText(component) : '--' }}</span>
                </div>
                <div class="detail-item" [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_RELEASE' | transloco: { version: component.version ? component.version : '--' }">
                  <span class="detail-label">{{ 'ACTIVITY_DETAILS.RELEASE' | transloco }}</span>
                  <span class="detail-value">{{ component.version ? component.version : '--' }}</span>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  } @else if (hasActiveFilters) {
    <div class="empty-state">
      <img class="w-106" alt="jobs not found" src="/assets/images/service_not_found.png">
      <div class="empty-text">
        @if (selectedStatus !== 'all') {
          {{ emptyMessage }}
        } @else {
          {{ 'ACTIVITY_DETAILS.NO_SEARCH' | transloco }}
        }
      </div>
    </div>
  }
</div>